import * as React from 'react';
export default function YoutubeVideo({ id: _id, }) {
    const id = _id
        .replace('https://www.youtube.com/watch?v=', '')
        .replace('https://www.youtube.com/embed/', '');
    return (React.createElement("div", { className: "w-100 mw6 center" },
        React.createElement("div", { style: {
                position: 'relative',
                width: '100%',
                paddingBottom: '56.25%',
            } },
            React.createElement("iframe", { style: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                }, src: `https://www.youtube.com/embed/${id}`, frameBorder: 0, allowFullScreen: true }))));
}
//# sourceMappingURL=YoutubeVideo.js.map